import {
  useQuery, useInfiniteQuery, UseQueryResult, UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getNotes } from '../../services/NotesService';
import { NotesResponse } from '../../types/Notes';

function useGetNotes(fleetId: string, entityName: string, entityId: string, query: string): UseQueryResult<NotesResponse> {
  return useQuery(
    ['notes', fleetId, entityName, entityId, query],
    async (): Promise<NotesResponse> => getNotes(fleetId, entityName, entityId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export function useGetNotesLazy(fleetId: string, payload?: any, query?: string, deps?: any): UseInfiniteQueryResult<NotesResponse> {
  return useInfiniteQuery(
    ['notes-lazy', fleetId, payload?.entityName, payload?.entityId, deps],
    async ({ pageParam = query }): Promise<NotesResponse> => getNotes(fleetId, payload?.entityName || '', payload?.entityId || '', pageParam),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      cacheTime: 0,
      getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    },
  );
}

export default useGetNotes;
